import { render, staticRenderFns } from "./ExpirableBalance.vue?vue&type=template&id=6f41d5d7&scoped=true"
import script from "./ExpirableBalance.vue?vue&type=script&lang=ts"
export * from "./ExpirableBalance.vue?vue&type=script&lang=ts"
import style0 from "./ExpirableBalance.vue?vue&type=style&index=0&id=6f41d5d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f41d5d7",
  null
  
)

export default component.exports